(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[723],{

/***/ 60342:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/park/[park]",
      function () {
        return __webpack_require__(63070);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/GlobeAltIcon.js


function GlobeAltIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(GlobeAltIcon);
/* harmony default export */ var esm_GlobeAltIcon = (ForwardRef);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/card.module.css
var card_module = __webpack_require__(49969);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
;// CONCATENATED MODULE: ./components/global/card.jsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

/* eslint-disable @next/next/no-img-element */ 




function Card(_param) {
    var props = _extends({}, _param);
    var link = props.link, image = props.image, title = props.title, type = props.type, additional = props.additional, location = props.location;
    var user = (0,react.useContext)(app/* default */.Z).user;
    // hack
    var isRestroom = title.toLowerCase().includes("restroom");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "group relative block",
            children: [
                (user === null || user === void 0 ? void 0 : user.CanAccessAdmin) && (location === null || location === void 0 ? void 0 : location.Latitude) && (location === null || location === void 0 ? void 0 : location.Longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 right-0 z-10 rounded-tr rounded-bl bg-blue-500 p-2",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_GlobeAltIcon, {
                        className: "h-4 w-4 fill-white"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "aria-hidden": "true",
                    className: "aspect-w-16 aspect-h-9 overflow-hidden rounded-lg group-hover:opacity-75",
                    children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext),
                        srcSet: "\n                https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext, " 800w,\n                https://images.opencoaster.com/600x300/").concat(image.hash).concat(image.ext, " 600w,\n                https://images.opencoaster.com/400x200/").concat(image.hash).concat(image.ext, " 400w,\n                https://images.opencoaster.com/300x150/").concat(image.hash).concat(image.ext, " 300w,\n                https://images.opencoaster.com/200x100/").concat(image.hash).concat(image.ext, " 200w,\n                https://images.opencoaster.com/100x50/").concat(image.hash).concat(image.ext, " 100w\n              "),
                        alt: image.alternativeText ? image.alternativeText : title,
                        className: "h-full w-full object-cover object-center"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-full w-full bg-gray-200 object-cover object-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center ".concat((card_module_default()).contents),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "flex",
                                src: "/placeholder-".concat(isRestroom ? "restroom" : type, ".svg"),
                                alt: title
                            })
                        })
                    })
                }),
                additional && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3 text-sm text-gray-500",
                    children: additional
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-base font-semibold text-gray-900 ".concat(!additional ? "mt-3" : ""),
                    children: title
                })
            ]
        })
    });
};


/***/ }),

/***/ 78932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29655);


function SectionText(param) {
    var section = param.section;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-section-type": section.__typename,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "prose mb-3 lg:prose-xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_1__/* .ReactMarkdown */ .D, {
                children: section.Content
            })
        })
    });
};


/***/ }),

/***/ 87676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/sections/SectionHeader.jsx

function SectionHeader(param) {
    var section = param.section;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-section-type": section.__typename,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            id: section.Anchor,
            className: "mb-3 font-serif text-3xl text-gray-800",
            children: section.Header
        })
    });
};

// EXTERNAL MODULE: ./components/sections/SectionText.jsx
var SectionText = __webpack_require__(78932);
;// CONCATENATED MODULE: ./components/sections/index.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Sections(_param) {
    var sections = _param.sections, _className = _param.className, className = _className === void 0 ? "mb-10" : _className, props = _objectWithoutProperties(_param, [
        "sections",
        "className"
    ]);
    if (!sections || !sections.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: className
    }, props, {
        children: sections.map(function(section) {
            if (section.__typename === "ComponentTextSectionHeader") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                    section: section
                }, section.id);
            }
            if (section.__typename === "ComponentTextText") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionText/* default */.Z, {
                    section: section
                }, section.id);
            }
            console.log("UNUSED SECTION", {
                section: section
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        })
    }));
}
/* harmony default export */ var sections = (Sections);


/***/ }),

/***/ 63070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Park; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 129 modules
var react_markdown = __webpack_require__(29655);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./context/app.js
var app = __webpack_require__(40714);
// EXTERNAL MODULE: ./components/global/breadcrumbs.jsx
var global_breadcrumbs = __webpack_require__(43228);
// EXTERNAL MODULE: ./components/global/cover.jsx
var cover = __webpack_require__(16763);
// EXTERNAL MODULE: ./components/throw404.jsx
var throw404 = __webpack_require__(36551);
// EXTERNAL MODULE: ./components/sections/index.jsx + 1 modules
var sections = __webpack_require__(87676);
// EXTERNAL MODULE: ./components/sections/SectionText.jsx
var SectionText = __webpack_require__(78932);
// EXTERNAL MODULE: ./components/global/card.jsx + 1 modules
var card = __webpack_require__(13693);
// EXTERNAL MODULE: ./components/global/attributes.jsx
var global_attributes = __webpack_require__(45033);
// EXTERNAL MODULE: ./components/global/gallery.jsx + 2 modules
var gallery = __webpack_require__(37999);
// EXTERNAL MODULE: ./queries/park.js + 1 modules
var park = __webpack_require__(41449);
;// CONCATENATED MODULE: ./components/parks/park-details.jsx

/* eslint-disable react/no-array-index-key */ 















var EditPanel = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(529), __webpack_require__.e(939)]).then(__webpack_require__.bind(__webpack_require__, 17939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17939)
            ];
        }
    },
    ssr: false
});
var EditLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 673).then(__webpack_require__.bind(__webpack_require__, 32673));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32673)
            ];
        }
    },
    ssr: false
});
function ParkDetails() {
    var ref6, ref1, ref2;
    var ref3 = (0,react.useContext)(app/* default */.Z), setRecommendedRecentPark = ref3.setRecommendedRecentPark, setRecommendedRecentResort = ref3.setRecommendedRecentResort;
    var ref4 = (0,react.useState)(false), editOpen = ref4[0], setEditOpen = ref4[1];
    var router = (0,next_router.useRouter)();
    var variables = {
        slug: router.query.park
    };
    var ref5 = (0,dist/* default */.ZP)([
        park/* default */.Z,
        variables
    ]), data = ref5.data, error = ref5.error;
    if (error) {
        console.log(error);
    }
    (0,react.useEffect)(function() {
        var park = data === null || data === void 0 ? void 0 : data.parks[0];
        setRecommendedRecentPark(park);
        if (park === null || park === void 0 ? void 0 : park.Resort) {
            setRecommendedRecentResort(park.Resort);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.parks,
        setRecommendedRecentPark,
        setRecommendedRecentResort
    ]);
    var park1 = data === null || data === void 0 ? void 0 : data.parks[0];
    if (!Array.isArray(data === null || data === void 0 ? void 0 : data.parks) || !(data === null || data === void 0 ? void 0 : (ref6 = data.parks) === null || ref6 === void 0 ? void 0 : ref6.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(throw404/* default */.Z, {});
    }
    var description = "Information on rides, shows and other attractions found at ".concat(park1.Name);
    if (park1.Resort) {
        description = "".concat(description, " in ").concat(park1.Resort.Name);
    }
    var CoverPhoto = "";
    var ParkTitle = "";
    if (park1.CoverPhoto || park1.MainPhoto) {
        CoverPhoto = /*#__PURE__*/ (0,jsx_runtime.jsx)(cover/* default */.Z, {
            title: park1.Name,
            image: park1.CoverPhoto || park1.MainPhoto
        });
    } else {
        ParkTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: "mb-10 font-serif text-5xl text-gray-800",
            children: park1.Name
        });
    }
    var breadcrumbs = [];
    if (Array.isArray(park1.Companies) && park1.Companies.length > 0) {
        var company = park1.Companies[0];
        breadcrumbs.push({
            name: company.Name,
            link: "/company/[company]",
            linkAs: "/company/".concat(company.Slug)
        });
    }
    if (park1.Resort) {
        var resort = park1.Resort;
        breadcrumbs.push({
            name: resort.Name,
            link: "/resort/[resort]",
            linkAs: "/resort/".concat(resort.Slug)
        });
    }
    breadcrumbs.push({
        name: park1.Name,
        link: "/park/[park]",
        linkAs: "/park/".concat(park1.Slug)
    });
    var attributes = [
        {
            ValueType: "Status",
            Value: park1.CurrentlyOperating ? "Operational" : "Closed"
        },
        {
            ValueType: "Type",
            Value: park1.Type
        }, 
    ];
    // Todo handle these better, yuck
    if (park1.OpeningDate) {
        attributes.push({
            ValueType: "Opening Date",
            Value: park1.OpeningDate
        });
    }
    if (park1.ClosedDate) {
        attributes.push({
            ValueType: "Date Closed",
            Value: park1.ClosedDate
        });
    }
    if (park1.MaxCapacity) {
        attributes.push({
            ValueType: "Capacity",
            Value: park1.MaxCapacity
        });
    }
    // find landless attractions
    var landAttractions = new Set();
    var allAttractions = new Set();
    park1 === null || park1 === void 0 ? void 0 : (ref1 = park1.Attractions) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(attraction) {
        allAttractions.add(attraction.id);
    });
    park1 === null || park1 === void 0 ? void 0 : (ref2 = park1.Lands) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(land) {
        var ref;
        land === null || land === void 0 ? void 0 : (ref = land.Attractions) === null || ref === void 0 ? void 0 : ref.forEach(function(attraction) {
            landAttractions.add(attraction.id);
        });
    });
    var landlessAttractions = Array.from(allAttractions).filter(function(attraction) {
        return !landAttractions.has(attraction);
    });
    landlessAttractions = landlessAttractions.map(function(id) {
        var ref;
        return park1 === null || park1 === void 0 ? void 0 : (ref = park1.Attractions) === null || ref === void 0 ? void 0 : ref.find(function(attraction) {
            return (attraction === null || attraction === void 0 ? void 0 : attraction.id) === id;
        });
    });
    // cleanup some memory
    landAttractions.clear();
    allAttractions.clear();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            park1.Name,
                            " | Open Coaster"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: park1.Name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://opencoaster.com/park/".concat(park1.Slug)
                    }),
                    park1.MainPhoto && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://images.opencoaster.com/1200x630/".concat(park1.MainPhoto.hash).concat(park1.MainPhoto.ext)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://images.opencoaster.com/1200x600/".concat(park1.MainPhoto.hash).concat(park1.MainPhoto.ext)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:width",
                                content: "1200"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:height",
                                content: "630"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:alt",
                                content: park1.MainPhoto.alternativeText ? park1.MainPhoto.alternativeText : park1.Name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditPanel, {
                open: editOpen,
                setOpen: setEditOpen,
                park: park1
            }),
            CoverPhoto,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container m-6 mx-auto px-6 sm:px-0",
                children: [
                    ParkTitle,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_breadcrumbs/* default */.Z, {
                        items: breadcrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 gap-8 md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-last md:order-first md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sections/* default */.Z, {
                                        sections: park1.Sections
                                    }),
                                    Array.isArray(park1.SeasonalEvent) && park1.SeasonalEvent.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                className: "mb-3 font-serif text-4xl text-gray-800",
                                                children: [
                                                    park1.Lands.length > 1 ? "Seasonal Events" : "Seasonal Event",
                                                    ":"
                                                ]
                                            }),
                                            park1.SeasonalEvent.map(function(event) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: "mb-3 text-2xl text-gray-800",
                                                            children: event.Name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "prose mb-3 lg:prose-xl",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                                                source: event.Description
                                                            })
                                                        })
                                                    ]
                                                }, "event-".concat(event.id));
                                            })
                                        ]
                                    }),
                                    Array.isArray(park1.Attractions) && park1.Attractions.length > 0 && (!Array.isArray(park1.Lands) || park1.Lands.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-10 overflow-hidden rounded-lg bg-white shadow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-4 py-5 sm:p-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-5 border-b border-gray-200 pb-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "flex-1 text-2xl font-bold text-gray-900",
                                                            children: park1.Attractions.length > 1 ? "Attractions" : "Attraction"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-10 last-of-type:mb-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4",
                                                            children: park1.Attractions.map(function(attraction) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(card/* default */.Z, {
                                                                    link: "/park/".concat(park1.Slug, "/").concat(attraction.Slug),
                                                                    linkAs: "/park/[park]/[attraction]",
                                                                    title: attraction.Name,
                                                                    image: attraction.MainPhoto,
                                                                    type: "attraction",
                                                                    location: attraction === null || attraction === void 0 ? void 0 : attraction.Location
                                                                }, "attraction-".concat(attraction.id));
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    Array.isArray(park1.Lands) && park1.Lands.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-10 overflow-hidden rounded-lg bg-white shadow",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "px-4 py-5 sm:p-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-5 border-b border-gray-200 pb-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "flex-1 text-2xl font-bold text-gray-900",
                                                            children: "Attractions"
                                                        })
                                                    }),
                                                    (landlessAttractions === null || landlessAttractions === void 0 ? void 0 : landlessAttractions.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-10 last-of-type:mb-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4",
                                                            children: landlessAttractions.map(function(attraction) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(card/* default */.Z, {
                                                                    link: "/park/".concat(park1.Slug, "/").concat(attraction.Slug),
                                                                    linkAs: "/park/[park]/[attraction]",
                                                                    title: attraction.Name,
                                                                    image: attraction.MainPhoto,
                                                                    type: "attraction",
                                                                    location: attraction === null || attraction === void 0 ? void 0 : attraction.Location
                                                                }, "attraction-card-".concat(attraction.id));
                                                            })
                                                        })
                                                    }),
                                                    park1.Lands.map(function(land, i) {
                                                        var ref;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                            className: "mb-10 last-of-type:mb-0",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                    className: "mb-3 text-xl font-medium text-gray-900",
                                                                    children: land === null || land === void 0 ? void 0 : land.Name
                                                                }),
                                                                (land === null || land === void 0 ? void 0 : (ref = land.Content) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionText/* default */.Z, {
                                                                    section: land
                                                                }),
                                                                Array.isArray(land === null || land === void 0 ? void 0 : land.Attractions) && land.Attractions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4",
                                                                    children: land.Attractions.map(function(attraction) {
                                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(card/* default */.Z, {
                                                                            link: "/park/".concat(park1.Slug, "/").concat(attraction.Slug),
                                                                            linkAs: "/park/[park]/[attraction]",
                                                                            title: attraction.Name,
                                                                            image: attraction.MainPhoto,
                                                                            type: "attraction",
                                                                            location: attraction === null || attraction === void 0 ? void 0 : attraction.Location
                                                                        }, "attraction-land-card-".concat(attraction.id));
                                                                    })
                                                                })
                                                            ]
                                                        }, "land-".concat(i));
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gallery/* default */.Z, {
                                        item: park1
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-first md:order-last md:col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    role: "list",
                                    className: "space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_attributes/* default */.Z, {
                                            attributes: attributes,
                                            title: "Key Facts"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditLink, {
                                            setEditOpen: setEditOpen
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/park/[park].jsx



var __N_SSG = true;
function Park(param) {
    var fallback = param.fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(config/* default */.Z, {
        fallback: fallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParkDetails, {})
    });
};


/***/ }),

/***/ 17221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RichText on ComponentTextText {\n    __typename\n    Content\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RichText = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (RichText);


/***/ }),

/***/ 89847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SectionHeader on ComponentTextSectionHeader {\n    __typename\n    Header\n    Anchor\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SectionHeader = (0,graphql_request__WEBPACK_IMPORTED_MODULE_0__.gql)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ }),

/***/ 41449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ park; }
});

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./queries/fragments/MainPhoto.js
var MainPhoto = __webpack_require__(20519);
// EXTERNAL MODULE: ./queries/fragments/SectionHeader.js
var SectionHeader = __webpack_require__(89847);
// EXTERNAL MODULE: ./queries/fragments/RichText.js
var RichText = __webpack_require__(17221);
;// CONCATENATED MODULE: ./queries/fragments/AttractionCard.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AttractionCard on Attraction {\n    id\n    Slug\n    Name\n    Location {\n      Latitude\n      Longitude\n    }\n    MainPhoto {\n      ...MainPhoto\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AttractionCard = (0,dist.gql)(_templateObject());
/* harmony default export */ var fragments_AttractionCard = (AttractionCard);

;// CONCATENATED MODULE: ./queries/park.js
function park_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function park_templateObject() {
    var data = park_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query Park($slug: String!) {\n    parks(where: { Slug: $slug }) {\n      __typename\n      id\n      Name\n      Slug\n      OpeningDate\n      ClosedDate\n      CurrentlyOperating\n      IsTempClosed\n      Type\n      Companies {\n        id\n        Name\n        Slug\n      }\n      Resort {\n        id\n        Name\n        Slug\n      }\n      Attractions {\n        ...AttractionCard\n      }\n      CoverPhoto {\n        ...MainPhoto\n      }\n      MainPhoto {\n        ...MainPhoto\n      }\n      Lands {\n        __typename\n        Name\n        Content\n        Attractions {\n          ...AttractionCard\n        }\n      }\n      Sections {\n        ...SectionHeader\n        ...RichText\n      }\n      SeasonalEvent {\n        id\n        Name\n        Description\n        StartDate\n        EndDate\n      }\n      Location {\n        Latitude\n        Longitude\n      }\n    }\n  }\n"
    ]);
    park_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PARK_QUERY = (0,dist.gql)(park_templateObject(), MainPhoto/* default */.Z, SectionHeader/* default */.Z, RichText/* default */.Z, fragments_AttractionCard);
/* harmony default export */ var park = (PARK_QUERY);


/***/ }),

/***/ 49969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contents":"card_contents__EHihQ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,269,486,263,774,888,179], function() { return __webpack_exec__(60342); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);